﻿import './urlHelperService.js';

export default 'urlHelper';
